import React from "react";
import { useNavigate } from "react-router-dom";
import NavigationHeader from "../../components/ui/NavigationHeader";
import Icon from "../../components/AppIcon";

const financeTabs = [
  {
    title: "DRE",
    description: "Resultado, comparação de receitas/despesas e indicadores do negócio.",
    icon: "LineChart",
    path: "/financeiro/dre",
  },
  {
    title: "Fluxo de Caixa",
    description: "Entradas, saídas, saldo inicial configurável e saldo diário.",
    icon: "ArrowLeftRight",
    path: "/financeiro/fluxo-caixa",
  },
  {
    title: "Análise de Inadimplência",
    description: "Clientes em atraso, vendedores, aging list e sinal verde/amarelo/vermelho.",
    icon: "AlertTriangle",
    path: "/financeiro/inadimplencia",
  },
  {
    title: "Contas a Receber",
    description: "Recebíveis, clientes em aberto, inadimplência e análise por vendedor.",
    icon: "WalletCards",
    path: "/financeiro/contas-receber",
  },
  {
    title: "Cobranças Automáticas",
    description: "Régua de cobrança, campanhas, histórico e envios automáticos.",
    icon: "Send",
    path: "/financeiro/cobrancas-automaticas",
  },
  {
    title: "Contas a Pagar",
    description: "Fornecedores, vencimentos, aging e programação de pagamentos.",
    icon: "ReceiptText",
    path: "/financeiro/contas-pagar",
  },
];

function FinanceCard({ item, onOpen }) {
  return (
    <button
      type="button"
      onClick={() => onOpen(item.path)}
      className={`rounded-[22px] border p-5 text-left transition hover:-translate-y-0.5 hover:shadow-md ${item.active ? "border-[#f4a300] bg-[#fff3df]" : "border-[#ead8c2] bg-white hover:border-[#f4a300] hover:bg-[#fffaf4]"}`}
    >
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-[#fff3df] text-[#d97706]">
        <Icon name={item.icon} size={20} />
      </div>
      <div className="text-base font-semibold text-[#3b1d0f]">{item.title}</div>
      <p className="mt-2 text-sm leading-relaxed text-[#7a5c46]">{item.description}</p>
      <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#9a5b00]">
        Abrir aba <Icon name="ArrowRight" size={15} />
      </div>
    </button>
  );
}

export default function FinanceiroDashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f7efe2] text-[#3b1d0f]">
      <NavigationHeader />
      <main className="px-4 pb-10 pt-24 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-[1500px] flex-col gap-6">
          <section className="rounded-[28px] border border-[#ead8c2] bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full border border-[#ead8c2] bg-[#fffaf4] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[#8b6a52]">
                  <Icon name="Landmark" size={14} /> Financeiro
                </span>
                <h1 className="mt-4 text-3xl font-bold text-[#3b1d0f]">Financeiro</h1>
                <p className="mt-2 max-w-3xl text-sm leading-relaxed text-[#7a5c46]">
                  Aqui ficam somente as abas financeiras. A Visão Geral continua separada no menu principal, com os KPIs gerais do sistema.
                </p>
              </div>
            </div>
          </section>

          <section className="rounded-[24px] border border-[#ead8c2] bg-white p-5 shadow-sm">
            <div className="mb-5 flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#fff3df] text-[#d97706]">
                <Icon name="LayoutDashboard" size={18} />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-[#3b1d0f]">Áreas do Financeiro</h2>
                <p className="text-sm text-[#7a5c46]">Entre nas telas financeiras sem deixar esses itens espalhados no menu superior.</p>
              </div>
            </div>

            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
              {financeTabs.map((item) => (
                <FinanceCard key={item.path} item={item} onOpen={navigate} />
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
